import axios from 'axios'

import {
    PayslipResource,
    UserDocumentViewModel,
} from '@/models'
import { transformPayslipResourceToUserDocument } from '@/services/UserDocumentService/transformPayslipResourceToUserDocument'

import { getLoketBridgeApiUrl } from './loket'

export async function getUserPayslips(
    employmentId: string,
    year?: number,
): Promise<UserDocumentViewModel[]> {
    try {
        const response = await axios
            .get<PayslipResource[]>(`${getLoketBridgeApiUrl()}/payslips/${employmentId}`)

        return response
            .data
            .map((payslip) => transformPayslipResourceToUserDocument(payslip))
            .filter((payslip) => (year ? payslip.createdAt.getFullYear() === year : true))
    } catch (error) {
        console.error('[getUserPayslips]', error)
        return []
    }
}
